import { messaging, vapidKey, getToken } from "./firebase-min";

getToken(messaging, { vapidKey: vapidKey })
	.then((token) => {
		if (token) {
		    window.FIREBASE_FCM_TOKEN = token;
            document.getElementById("fcm_token").value = token;
		} else {
		    console.error("No registration token available.");
		}
	})
	.catch((err) => {
		console.error("An error occurred while retrieving token. ", err);
	});